module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/breastfeeding-998932560e89534febd9cca5efec4661.svg";